var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"9BSULy5rapT685LI4_Z8b"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["storefront@nyati-mexico-sa-de-cv"]={id:"9BSULy5rapT685LI4_Z8b"};
      